import React, {useEffect, useState} from 'react';
import { useMoralisQuery } from "react-moralis";
import { VStack, Button, Box,  Tag, Text, Spacer, HStack, Flex, Radio, RadioGroup, Img } from '@chakra-ui/react';
import { useMoralis } from 'react-moralis';

import { Link } from 'react-router-dom';
import { useNewMoralisObject } from 'react-moralis';
import { Connect } from '../components/Connect';
import TG from '../assets/tg.png'
import Discord from '../assets/discord.png'
import CDC from '../assets/CDC.png'

function Vote2() {

   const { account } = useMoralis();
    const [address, setAddress] = useState(String(account));
  const [buttBalance, setButtBalance] = useState(0);



useEffect(() => {
  if (String(account).includes("0x")) {
      const API_KEY_CRONOSCAN = "57VGVCF7UM4H74I2XA5AJ4WC4TAI2TJDKC";
  const Address=String(account);
          // Function to get token balance
          const getTokenBalance = async (Address: string | null) => {
              try {
                  // API URL
                  const apiUrl = `https://api.cronoscan.com/api?module=account&action=tokenbalance&contractaddress=0x2dfA528939D38a3654ad44a4748BE591e283a32f&address=${Address}&tag=latest&apikey=${API_KEY_CRONOSCAN}`;

              // Make an HTTP GET request to the API using fetch
              const response = await fetch(apiUrl);
              const data = await response.json();

              if (data && data.status === "1") {
                  // Return the token balance
                  const balance = data.result;
                  console.log(`Token Balance: ${balance}`);
                  setButtBalance(balance);
                  if (balance ===0 || balance==="0"){
                    setDisabled(true);
                  }


                  return balance;
              } else {
                  throw new Error(data.message || "Failed to fetch token balance");
              }
          } catch (error) {
              console.error("Error fetching token balance:", error.message);
              throw error;
          }
      };

      // Fetch the token balance
      (async () => {
          try {
              const balance = await getTokenBalance(account);
              console.log(`Token Balance for account ${account}: ${balance}`);
          } catch (error) {
              console.error("Unable to get token balance.");
          }
      })();

     
  }
  }, [account]);

  const [value, setValue] = React.useState('0x2dfA528939D38a3654ad44a4748BE591e283a32f')

  // eslint-disable-next-line
  const [data1, setData1] = useState(0);
  const [data2, setData2] = useState('');
  const [data3, setData3] = useState(0);
  const [newdata3, setnewData3] = useState(0);
  const [data4, setData4] = useState('');
  const [data5, setData5] = useState(0);
  const [newdata5, setnewData5] = useState(0);
  const [data6, setData6] = useState('');
  // eslint-disable-next-line
  const [newdata1, setnewData1] = useState(0);
  const Question="what socials should we use in project croham and $BUTT?"
  const option1="Telegram"
  const option2= "Discord"
  const option3= "It's vital to have both"


  const limitQuery = useMoralisQuery("ButtVoteOption1", (query) => query.limit(100), [], 
  {autoFetch: false,}); 

  console.log("This is account:", String(account))
  useEffect(() => {
  
    limitQuery.fetch({
      onSuccess: (result) => {
        setData1(Number(result[result.length - 1]?.attributes?.votescore1 || 0));
        setnewData1(data1);
        console.log("data1:", data1);
      },
    }).catch((error) => console.error(error));
  }, [account]);

  useEffect(() => {
  
    limitQuery.fetch({
        onSuccess: (result) => {setData2(String(JSON.stringify(result))), console.log("data2:",data2)}})

    // eslint-disable-next-line
  .catch(error => console.error(error))

  console.log(data2)
  }, [account]);

  useEffect(() => {

    limitQuery.fetch({
      onSuccess: (result) => {
        setData3(Number(result[result.length - 1]?.attributes?.votescore2 || 0));
        setnewData3(data3);
        console.log("data3:", data3);
      },
    }).catch((error) => console.error(error));
  }, [account]);

  useEffect(() => {
  
    limitQuery.fetch({
      onSuccess: (result) => {
        setData5(Number(result[result.length - 1]?.attributes?.votescore3 || 0));
        setnewData5(data5);
        console.log("data5:", data5);
      },
    }).catch((error) => console.error(error));
  }, [account]);


    useEffect(() => {
  
    limitQuery.fetch({
        onSuccess: (result) => {setData4(String(JSON.stringify(result))), console.log("data4", data4)}})
        // eslint-disable-next-line
      .catch(error => console.error(error))

  }, [account]);


    useEffect(() => {
  
    limitQuery.fetch({
        onSuccess: (result) => {setData6(String(JSON.stringify(result))), console.log("data6 :", data6)}})
        // eslint-disable-next-line
      .catch(error => console.error(error))

  }, [value,account]);



  const  {save}  = useNewMoralisObject("ButtVoteOption1");

const addVotes = async () => {

  const data = {

  };

   
  save(data, {
    onSuccess: (ButtVoteOption1) => {
      ButtVoteOption1.set("accountsVoted",String(account));
      ButtVoteOption1.set("votescore1",Number(vote1score));
      ButtVoteOption1.set("votescore2",Number(data3));
      ButtVoteOption1.set("votescore3",Number(data5));
      ButtVoteOption1.save();
console.log("AddVotes working")
}

});

};

const addVotes2 = async () => {

  const data = {

  };
 
  save(data, {
    onSuccess: (ButtVoteOption1) => {
      ButtVoteOption1.set("accountsVoted",String(account));
      ButtVoteOption1.set("votescore1",Number(data1));
      ButtVoteOption1.set("votescore2",Number(vote2score));
      ButtVoteOption1.set("votescore3",Number(data5));

  ButtVoteOption1.save();
}
});
};

const addVotes3 = async () => {

  const data = {

  };
 
  save(data, {
    onSuccess: (ButtVoteOption1) => {
      ButtVoteOption1.set("accountsVoted",String(account));
      ButtVoteOption1.set("votescore1", Number(data1));
      ButtVoteOption1.set("votescore2",Number(data3));
      ButtVoteOption1.set("votescore3",Number(vote3score));

  ButtVoteOption1.save();
}
});
};
    
const [isDisabled, setDisabled] = useState(false);
   // eslint-disable-next-line

   const numberOfVotes:number=Number((buttBalance/1000000000000000000000).toFixed(0));

   const increment1 = () => { 
    setData1((prev: number) => prev + numberOfVotes);
    setDisabled(true);
    addVotes();
  };
  
  const increment2 = () => {
    setData3((prev: number) => prev + numberOfVotes); // Apply the same logic as increment1
    setDisabled(true);
    addVotes2();
  };
  
  const increment3 = () => {
    setData5((prev: number) => prev + numberOfVotes); // Apply the same logic as increment1
    setDisabled(true);
    addVotes3();
  };
  // eslint-disable-next-line

// eslint-disable-next-line
const vote1score:number=data1+numberOfVotes;
const vote2score:number=data3+numberOfVotes;
const vote3score:number=data5+numberOfVotes;
    
if (!account) {
  return (
    <VStack
      background="linear-gradient(135deg, rgba(0, 0, 0, 0.9), rgba(40, 40, 40, 0.8))"
      color="white"
      height="100vh"
     
      alignItems="center"
      spacing="8"
    >
      <Box textAlign="center" padding="5" boxShadow="xl" borderRadius="lg" bg="rgba(255, 255, 255, 0.05)">
        <Link to="/" style={{ fontSize: "1.5vmax", textDecoration: "underline" }}>
          PLEASE LOGIN to vote
        </Link>
        <Spacer padding={5} />
        <Connect />
      </Box>
    </VStack>
  );
}


  return (
    <VStack
    width={'fit-content'}
      background="linear-gradient(135deg, rgba(0, 0, 0, 0.9), rgba(40, 40, 40, 0.8))"
      color="white"
    
      height="100vh"
   
      alignItems="center"
      textAlign="center"
      spacing="6"
      padding="5"
    >
      <Box  alignSelf={"center"}  width={'fit-content'} padding="5"  boxShadow="lg" borderRadius="lg" bg="rgba(255, 255, 255, 0.05)">
        <Text  fontSize="1.8vmax" marginBottom="6">
         <span style={{textDecoration:'underline'}}>COMMUNITY VOTE</span> 
        <br></br>  ONE $BUTT = ONE VOTE. LET'S VOTE!
        <br></br>  AND NO F *** BUTS!
       
        </Text>
        <Text fontSize="1.5vmax" padding="4" border="1px" borderColor="whiteAlpha.500" borderRadius="xl">
          {Question}
        </Text>

        <Spacer padding={5} />
         <RadioGroup hidden onChange={setValue} value={value}>
          <HStack justifyContent="center" spacing="8" marginBottom="6">
            <Radio value="0x2dfA528939D38a3654ad44a4748BE591e283a32f" fontSize="1.2vmax">
              Buttman On Cro
            </Radio>
            <Radio value="0x000" fontSize="1.2vmax">
            Project 1
          </Radio>
          <Radio value="0x000" fontSize="1.2vmax">
            Project 2
          </Radio>
          </HStack>
        </RadioGroup>

        <Flex alignItems={"center"}  direction="column" gap="4">
          <Tag
             width={'fit-content'}
  size="lg"
  borderRadius="full"
  padding="1vmax"
  backgroundColor="rgba(0, 0, 0, 0.7)"
  _hover={{ backgroundColor: "rgba(0, 128, 0, 0.9)" }}
>
  <Button
     width={'fit-content'}
    colorScheme="blue"
    variant="solid"
    fontSize="1vmax"
    borderRadius="full"
    padding="1.5vmax"
    onClick={increment1}
    isDisabled={data4.includes(String(account)) || data2.includes(String(account)) || buttBalance === 0 ? true : isDisabled}
    _hover={{ bg: "green.600" }}
    leftIcon={
      <Img
        src={TG} // Replace this with any icon/image you prefer
        alt="Option 1 Icon"
        boxSize="1.5vmax"
        borderRadius="full"
      />
    }
  >
    {option1}
    <Spacer paddingInline="1vmax" />
    ({data1} K VOTES SO FAR) / {data1/ (data1 + data3 + data5)*100}%
  </Button>
</Tag>


          <Tag
             width={'fit-content'}
  size="lg"
  borderRadius="full"
  padding="1vmax"
  backgroundColor="rgba(0, 0, 0, 0.7)"
  _hover={{ backgroundColor: "rgba(0, 128, 0, 0.9)" }}
>
  <Button
     width={'fit-content'}
    colorScheme="green"
    variant="solid"
    fontSize="1vmax"
    borderRadius="full"
    padding="1.5vmax"
    onClick={increment2}
    isDisabled={data4.includes(String(account)) || data2.includes(String(account)) ? true : isDisabled}
    _hover={{ bg: "green.600" }}
    leftIcon={
      <Img
        src={Discord} // Replace this with any icon/image you prefer
        alt="Option 2 Icon"
        boxSize="1.5vmax"
        borderRadius="full"
      />
    }
  >
    {option2}
    <Spacer paddingInline="1vmax" />
    ({data3} K VOTES SO FAR)/ {data3/ (data1 + data3 + data5)*100}%
  </Button>
</Tag>


<Tag
   width={'fit-content'}
  size='xxl'
  borderRadius="full"
  padding="1vmax"
  backgroundColor="rgba(0, 0, 0, 0.7)"
  _hover={{ backgroundColor: "rgba(0, 128, 0, 0.9)" }}
>
  <Button
      width={'fit-content'}
    colorScheme="red"
    variant="solid"
    fontSize="1vmax"
    borderRadius="full"
    padding="1.5vmax"
    onClick={increment3}
    isDisabled={data4.includes(String(account)) || data2.includes(String(account)) ? true : isDisabled}
    _hover={{ bg: "green.600" }}
    leftIcon={
      <Img
        src={CDC} // Replace this with any icon/image you prefer
        alt="Option 3 Icon"
        boxSize="1.5vmax"
        borderRadius="full"
      />
    }
  >
    {option3}
    <Spacer paddingInline="1vmax" />
    ({data5} K VOTES SO FAR) / {data5/ (data1 + data3 + data5)*100}%
  </Button>
</Tag>

        </Flex>

        <Spacer padding={"5vmax"} />
        <Tag fontSize="1.5vmax" borderWidth={'0.3vmax'} textColor={'red'} borderColor={'red'} background={'yellow'} padding="3" borderRadius="full" boxShadow="md">
          WEIGHTED VOTES IN TOTAL: {data1 + data3 + data5} K / {(((data1 + data3 + data5)/1000000)*100).toFixed(0)}%
        </Tag>
        <Spacer padding={5} />
        
        <Link hidden={!isDisabled} to="/" style={{ fontSize: "1.2vmax", textDecoration: "underline" }}>
          THANKS FOR VOTING!
        </Link>
      </Box>
    </VStack>
  );
}








export default Vote2;